import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { getFirestore, collection, orderBy, limit, startAfter, query, getDocs, onSnapshot, doc, getDoc, updateDoc, setDoc, where, arrayUnion, deleteDoc } from 'firebase/firestore'
import { initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from "firebase/app-check";
import { getPrj } from '../constants/methods';
import BDS from '../constants/bds'
import axios from 'axios'
import { getAlertStatsReportFromDb } from '../services/alertReports';

import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";

const n = getPrj();
const app = initializeApp(BDS[n]);
let bypassFunctionsEmulatorConnected = false;

const initAppCheck = () => {
    const siteKey = process.env[`REACT_APP_APPCHECK_SITE_KEY_${n.toUpperCase()}`];
    if (!siteKey || typeof window === 'undefined') return;

    const debugToken = process.env[`REACT_APP_APPCHECK_DEBUG_TOKEN_${n.toUpperCase()}`];
    if (debugToken) window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;

    const providerType = process.env[`REACT_APP_APPCHECK_PROVIDER_${n.toUpperCase()}`];
    const provider = providerType === 'enterprise'
        ? new ReCaptchaEnterpriseProvider(siteKey)
        : new ReCaptchaV3Provider(siteKey);

    initializeAppCheck(app, {
        provider,
        isTokenAutoRefreshEnabled: true
    });
};

initAppCheck();


// const logOut = async () => {
//     const au = getAuth(app);
//     await signOut(au);
//     // window.localStorage.clear()
//     localStorage.removeItem('sessionID'); //solo necesitamos limpiar la session realmente
//     localStorage.removeItem('viewedAlerts');
// }
const logOut = async () => {
    const au = getAuth(app);
    try {
        await signOut(au);
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = '/login'; // Forzar recarga total para limpiar RAM
    } catch (error) {
        console.error("Error al cerrar sesión", error);
    }
}


const getData = async (params) => {
    const db = getFirestore(app);
    const {coll, lim, start, order, direction='asc', service='TGD'} = params;
    const constraints = [];
    const visibleFilter = coll === 'alerts' && process.env.REACT_APP_SERVICES.indexOf(service) > -1;
    
    // Añadir aqui el service de los proyectos que llevan campo visible = true/false => SNOWFY no lleva campo visible (siempre visibles), CAJ no tiene alertas
    if (visibleFilter) {
        constraints.push(where('service', 'array-contains', service), where('visible', '==', true));
    } else {
        constraints.push(where('service', 'array-contains', service));
    }
    constraints.push(orderBy(order, direction));
    if (start) constraints.push(startAfter(start));
    constraints.push(limit(lim));

    const q = query(collection(db, coll), ...constraints);
    const snapshot = await getDocs(q); 
    return snapshot;
}

const getDocu = async (params) => {
    const db = getFirestore(app);
    const {coll, docu} = params;
    const ref1 = doc( db, coll, docu?.toString());
    const ref2 = await getDoc(ref1);
    let ret = ref2?.data() || null;
    return ret;
}

const getDocus = async (params) => {
    const db = getFirestore(app);
    const {coll, service=''} = params;      
    const q = service && service != '' ? 
                query(collection(db, coll), where('service', '==', service)) :
                query(collection(db, coll))
    const snapshot = await getDocs(q);  
    let ret = [];
    snapshot?.forEach(doc => { ret.push(doc.data())})
    return ret;
}

const getDocusArr = async (params) => {
    const db = getFirestore(app);
    const { coll, service = "", order, direction = 'asc' } = params;
    let q = null;
    const visibleFilter = coll === 'alerts' && process.env.REACT_APP_SERVICES.indexOf(service) > -1;

    if (service && service !== "") {
        if (visibleFilter) {
            q = order
                ? query(collection(db, coll), where('service', 'array-contains', service), where('visible', '==', true), orderBy(order, direction))
                : query(collection(db, coll), where('service', 'array-contains', service), where('visible', '==', true));
        } else {
            q = order
                ? query(collection(db, coll), where('service', 'array-contains', service), orderBy(order, direction))
                : query(collection(db, coll), where('service', 'array-contains', service));
        }
    } else {
        q = order
            ? query(collection(db, coll), orderBy(order, direction))
            : query(collection(db, coll));
    }

    const snapshot = await getDocs(q);  
    let ret = [];
    snapshot?.forEach(doc => { ret.push(doc.data()) });
    return ret;
};


const setDocu = async (params) => {
    try {
        const db = getFirestore(app);
        const {coll, docu, data, merge=false} = params;
        const ref = doc( db, coll, docu.toString());
        //await updateDoc(ref, data)
        delete data.merge
        await setDoc(ref, data, {merge:merge})
        //await setDoc(ref, data)
        return true;
    } catch(e) {
        console.error(e)
        return false;
    }
}

const updateDocu = async (params) => {
    try {
        const db = getFirestore(app);
        const {coll, docu, data} = params;
        const ref = doc( db, coll, docu.toString());
        await updateDoc(ref, data);
        return true;
    } catch(e) {
        console.error(e);
        return false;
    }
}


const deleteDocu = async (params) => {
    try {
        const db = getFirestore(app);
        const {coll, docu} = params;
        const ref = doc( db, coll, docu.toString());
        await deleteDoc(ref);
        return true;
    } catch(e) {
        console.error(e);
        return false;
    }
}

const getHook = (params, snapshot, error) => {
    const db = getFirestore(app);
    const {coll, lim, order, service='VERISURE'} = params;
    let q = null;
    
    // Añadir aqui el service de los proyectos que llevan campo visible = true/false => SNOWFY no lleva campo visible, CAJ no tiene alertas,  ¿SLAP, RACVN?
    if (coll === 'alerts' && process.env.REACT_APP_SERVICES.indexOf(service) > -1) {
        //(service == 'AHP' || service == 'REP' || service == 'TGD' || service == 'REMOTO2' || service == 'CASERCC' || service == 'DUCATI' || service == 'KYMCO')) { 
        if (!lim) { 
            q = query(collection(db, coll), where('service', 'array-contains', service) , where('visible', '==', true) , orderBy(order, 'desc'));
        } else {
            q = query(collection(db, coll), where('service', 'array-contains', service) , where('visible', '==', true) , orderBy(order, 'desc'), limit(lim));
        }
    } else {
        if (!lim) { 
            q = query(collection(db, coll), where('service', 'array-contains', service) , orderBy(order, 'desc'));
        } else {
            q = query(collection(db, coll), where('service', 'array-contains', service) , orderBy(order, 'desc'), limit(lim));
        }
    }
    return onSnapshot(q, snapshot, error);
};

const getHookB = (params, snapshot, error) => {
    const db = getFirestore(app);
    const {coll, id, service} = params;
// console.log(coll, service, id)    
    const q = query(collection(db, coll), where('service', '==', service), where('name', '==', id))
    return onSnapshot(q, snapshot, error);
};

const getWatchingHook = (params, snapshot, error) => {
    const db = getFirestore(app);
    const {coll, alertId=null} = params;
    return onSnapshot(doc(db, coll, alertId), snapshot, error);
};

const getWatchingReport = async (params) => {
    const db = getFirestore(app);
    const { alertId } = params;
    const pluspos = alertId.indexOf('+');
    const timestamp = Number(alertId.substring(0, pluspos));
    const d = new Date(timestamp);
    const phone = alertId.substring(pluspos);
    const y = d.getFullYear().toString();
    const m = (d.getMonth()+1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const ref1 = doc( db, `crashReports/${y}/${m}/${day}/${phone}`, timestamp.toString());
    const ref2 = await getDoc(ref1);
    //const doc = ref2; // await getDoc(collection(ref1, `${day}/${phone}`), alertId)
    let ret = ref2.data();
    if(ret?.hasLocations) ret.report = (await getDoc(await doc(ref1, 'heavyData', 'loc'))).data();
    return ret;
    /* 
    db.collection('crashReports').doc(syear)
        .collection(smonth).doc(sday)
        .collection(sphone).doc(id.toString()
    */
    //return getDoc(doc(db, coll, alertId));
}

const getWatchingImpacts = async (params) => {
    const { alertId, hasAccelerations, impacts } = params;
//console.log(impacts, hasAccelerations)    
    let ret = [];
    if(hasAccelerations && !impacts) {
        const db = getFirestore(app);
        const pluspos = alertId.indexOf('+');
        const timestamp = Number(alertId.substring(0, pluspos));
        const d = new Date(timestamp);
        const phone = alertId.substring(pluspos);
        const y = d.getFullYear().toString();
        const m = (d.getMonth()+1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        ///crashReports C /2022 D /04 C /04 D /+34656609838 C /1649063541767 D /heavyData C /acc D
        const ref1 = await doc( db, `crashReports/${y}/${m}/${day}/${phone}/${timestamp.toString()}/heavyData/`, 'acc');
        const ref2 = await getDoc(ref1);
        ret = ref2?.data()?.accelerations.map(a => {
            const d = new Date(a.time || a.accTime)
            const time = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}`
            return [time, a.accModule || a.mod]
        });
    }
    return ret;
}

const setSessionID = async (params) => {
    const { user, sessionID } = params;
    const db = getFirestore(app);
    const ref = doc( db, `users/`, user);
    /* await updateDoc(ref, {
        "sessionIDs": deleteField()
    }); */
    await updateDoc(ref, {
        "sessionIDs": [sessionID]
    })
    window.localStorage.setItem('sessionID', sessionID);
    const docData = await getDoc(ref);
    const service = docData?.data()?.service;
    window.localStorage.setItem('serviceID', service);
    return service;
}

const getUser = async (mail) => {
    if(!mail) return null;
    try {
        const db = getFirestore(app);
        const ref = doc( db, `users/`, mail);
        const docData = await getDoc(ref);
        const user = docData?.data();
        // console.log(`firebaseConfig -> getUserMenu ${JSON.stringify(rol)}`)
        return user;
    } catch(e) {
        console.log(`firebaseConfig -> getUserMenu: Error getting user rol ${e.message}`)
        console.log(e)
    }
}

const getStatistics = async (data) => {
    const tk = data.tk;
    delete(data.tk)
    const projectPath = getPrj().toLowerCase();

    // los proyectos por bypassweb habra que añadirlos aqui
    if (projectPath === 'tgd') {
        return await callBypassApi(`statistics/${projectPath}/getStats`, data);
    }

    const urlBase = process.env[`REACT_APP_API_URL_${getPrj().toUpperCase()}`] || process.env.REACT_APP_API_URL;
    const ret = await axios({
        method: "post",
        url: `${urlBase}/statistics/${projectPath}/getStats`,
        data: data, 
        headers: { Authorization: `Bearer ${tk}`}
    });
    const jasoncito = ret?.data?.detail;
    return  typeof jasoncito == 'object' ? jasoncito : JSON.parse(ret?.data?.detail);
}

const closeAlert = async (data) => {
    const { tk } = data;
    delete(data.tk);
    delete(data.service);
    const projectPath = getPrj().toLowerCase();

    // los proyectos por bypassweb habra que añadirlos aqui
    if (projectPath === 'tgd') {
        return await callBypassApi(`alerts/${projectPath}/setStatus`, data);
    }

    const urlBase = process.env[`REACT_APP_API_URL_${getPrj().toUpperCase()}`] || process.env.REACT_APP_API_URL;
    const ret = await axios({
        method: "post",
        url: `${urlBase}/alerts/${projectPath}/setStatus`,
        data: data, 
        headers: { Authorization: `Bearer ${tk}`}
    });
    const jasoncito = ret?.data;
    return  typeof jasoncito == 'object' ? jasoncito : JSON.parse(ret?.data?.detail);
}

const addToArray = async (params) => {
    //({coll: 'simulations', docu: id, arr: 'runtimes', data: docu})
    try {
        const db = getFirestore(app);
        const { coll, docu, arr, data } = params;

        const ref = doc( db, coll, docu.toString());
        await updateDoc(ref, {
            [arr]: arrayUnion(data)
            //'runtimes': arrayUnion('runtimes', ...[+new Date])
        })
        return true;
    } catch(e) {
        console.error(e.message)
        return false;
    }
}

const getHeatMap = async (data) => {
    // const tk = data.tk;
    data.module='maps';
    data.method = 'getHeatMap';

    try {
        return await callApi(data);
    } catch (e) {
        console.log(e);
        return [];
    }
}

const getAlertStatsReport = async (params) => {
    const db = getFirestore(app);
    return getAlertStatsReportFromDb(db, params);
}

const callApi = async (data) => {
    const { tk, module, method } = data; 
    delete(data.tk)
    delete(data.module);
    delete(data.method);
    const projectPath = getPrj().toLowerCase();
    const path = `${module}/${projectPath}/${ method }`;

    // los proyectos por bypassweb habra que añadirlos aqui
    if (projectPath === 'tgd') return await callBypassApi(path, data);

    const urlBase = process.env[`REACT_APP_API_URL_${getPrj().toUpperCase()}`] || process.env.REACT_APP_API_URL;
    const ret = await axios({
        method: "post",
        url: `${urlBase}/${path}`,
        data: data, 
        headers: { Authorization: `Bearer ${tk}`}
    });
    const json = ret?.data?.detail || [];
    return typeof json == 'object'? json : JSON.parse(json);
}

const callBypassApi = async (path, data) => {
    const region = process.env[`REACT_APP_REGION_${getPrj().toUpperCase()}`] || process.env.REACT_APP_REGION;
    const functions = getFunctions(app, region);
    const urlBase = process.env[`REACT_APP_API_URL_${getPrj().toUpperCase()}`] || process.env.REACT_APP_API_URL;

    if (!bypassFunctionsEmulatorConnected && urlBase?.indexOf('localhost') > -1) {
        const url = new URL(urlBase);
        connectFunctionsEmulator(functions, url.hostname, Number(url.port) || 5001);
        bypassFunctionsEmulatorConnected = true;
    }

    const bypassweb = httpsCallable(functions, 'bypassweb');
    const ret = await bypassweb({ ...data, path });
    const json = ret?.data?.detail || [];
    if (typeof json == 'object') return json;

    try {
        return JSON.parse(json);
    } catch (ignore) {
        return json;
    }
}

export { 
    app,
    initializeApp,
    signInWithEmailAndPassword,
    getFirestore,
    getAuth,
    logOut,
    getData,
    getHook,
    getHookB,
    getWatchingHook,
    getWatchingReport,
    getWatchingImpacts,
    setSessionID,
    getDocu,
    getDocus,
    getDocusArr,
    setDocu,
    getUser,
    getStatistics,
    addToArray,
    updateDocu,
    deleteDocu,
    closeAlert,
    getHeatMap,
    getAlertStatsReport,
    callApi
}
